import React, { useEffect, useState } from "react"
import Main from "./Main"
import { AzureAD, AuthenticationState } from "react-aad-msal"
import { authProvider } from "./authProvider"
import { Button, Col, Container, Row } from "react-bootstrap"
import "./App.css"
import log from "loglevel"
import Loading from "./Utils/Loading"
import UAI from "./UAI"
import localforage from "localforage"
import packageJson from "./version.json"
import ReactGA from "react-ga"
import { basicReduxStore } from "./reduxStore"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import FolletoWeb from "./Folleto/FolletoWeb"
import UAINavbar from "./Utils/UAINavbar"
import AddToCalendar from "./Utils/AddToCalendar"
import { JSONEditor } from "@json-editor/json-editor"

/**
 * Aplicación principal. Este componente se encarga de autenticar utilizando AzureAD
 * y pasar al componente Main el usuario una vez está autenticado.
 */
const App = () => {
  // Foto del usuario desde el AD
  const [userPic, setUserPic] = useState(null)
  // Versión de la App validada
  const [versionChecked, setVersionChecked] = useState(false)

  log.setDefaultLevel(log.levels.DEBUG)
  log.setLevel(log.levels.DEBUG)

  const divRef = React.useRef()

  useEffect(() => {
    // Inicialización de Google Analytics
    ReactGA.initialize("UA-22082085-1")

    // Storage local básico
    let storage = window.localStorage

    if (
      storage.getItem("version") !== undefined &&
      storage.getItem("version") !== packageJson.version
    ) {
      localforage.clear().then(() => {
        storage.setItem("version", packageJson.version)
        setVersionChecked(true)
      })
    } else {
      setVersionChecked(true)
    }
  }, [])

  if (!versionChecked) {
    return <Loading />
  }

  let isPublic = window.location.pathname.includes("www")

  if (isPublic) {
    return (
      <BrowserRouter basename={UAI.basename()}>
        <Routes>
          <Route
            path="/www/addtocalendar/:nombrecorto"
            element={<AddToCalendar />}
          ></Route>
          <Route path="/" element={<div>404!</div>}></Route>
        </Routes>
      </BrowserRouter>
    )
  }

  return (
    <Container className="mp-app-container">
      <AzureAD provider={authProvider} reduxStore={basicReduxStore}>
        {({ login, logout, authenticationState, error, accountInfo }) => {
          switch (authenticationState) {
            case AuthenticationState.Authenticated:
              if (userPic === null && !accountInfo.jwtAccessToken) {
                authProvider
                  .getAccessToken()
                  .then((tokenResponse) => {
                    window
                      .fetch(
                        "https://graph.microsoft.com/v1.0/users/" +
                          accountInfo.account.accountIdentifier +
                          "/photo/$value",
                        {
                          method: "GET",
                          headers: {
                            Authorization:
                              "Bearer " + tokenResponse.accessToken,
                            "Content-Type": "application/json",
                          },
                        }
                      )
                      .then((response) => {
                        response.arrayBuffer().then((buffer) => {
                          let base64Flag = "data:image/jpeg;base64,"
                          let binary = ""
                          let bytes = [].slice.call(new Uint8Array(buffer))
                          bytes.forEach(
                            (b) => (binary += String.fromCharCode(b))
                          )
                          let imageStr = window.btoa(binary)

                          let userpic = base64Flag + imageStr
                          setUserPic(userpic)
                        })
                      })
                      .catch((error) => {
                        setUserPic("")
                        log.error(error)
                      })
                  })
                  .catch((error) => {
                    setUserPic("")
                    log.error(error)
                  })
              }

              if (userPic === null) {
                return <Loading message="Cargando usuario uai.cl" />
              } else {
                let nombreUsuarioAD = accountInfo.account.userName.replace(
                  /@.*/,
                  ""
                )
                let periodo = UAI.obtienePeriodoPorDefecto(nombreUsuarioAD)
                let usuario = UAI.obtieneUsuarioInicial(nombreUsuarioAD)
                return (
                  <Main
                    accountInfo={{
                      username: nombreUsuarioAD,
                      identifier: accountInfo.account.accountIdentifier,
                      fullname: accountInfo.account.name,
                      authProvider: authProvider,
                      logout: logout,
                      userpic: userPic,
                    }}
                    periodo={periodo}
                    usuario={usuario}
                  />
                )
              }
            case AuthenticationState.Unauthenticated:
            case AuthenticationState.InProgress:
              log.debug("Unauthenticated")
              return (
                <Container className="mp-app-container mp-login-error">
                  <Row>
                    <Col>
                      <UAINavbar loading={true} />
                    </Col>
                  </Row>
                  {error && (
                    <Row>
                      <Col>
                        <p>
                          <span>
                            Hubo un error en la autenticación, por favor intente
                            nuevamente!
                          </span>
                        </p>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col xs={3}></Col>
                    <Col xs={6}>
                      <div className="mp-login-message">
                        {authenticationState ===
                          AuthenticationState.InProgress && (
                          <Loading message="Autenticando..." />
                        )}
                        {authenticationState ===
                          AuthenticationState.Unauthenticated && (
                          <>
                            <p>
                              ¡Hola! Estamos intentando redirigir su navegador
                              al sitio de autenticación de su cuenta UAI.
                            </p>
                            <p>
                              Si no se redirige automáticamente utilice el
                              botón:
                            </p>
                            <Button variant="primary" onClick={login}>
                              Ingresar
                            </Button>
                          </>
                        )}
                      </div>
                    </Col>
                    <Col xs={3}></Col>
                  </Row>
                </Container>
              )
            default:
              log.debug("Default case!")
              return (
                <div>
                  <p>Autenticando...</p>
                  <Loading />
                </div>
              )
          }
        }}
      </AzureAD>
    </Container>
  )
}

export default App
